import { Store } from '@ngrx/store';
import { VyVSharedProductCode } from 'src/app/api/models/vyVSharedProductCode';
import { PathType } from 'src/app/core/enums/path-type.enum';
import * as fromPath from 'src/app/core/state/path';
import { allowedDepartments } from 'src/app/views/general-information/address/address.allowedDepartment';
import { creteilPostalCode } from 'src/app/views/general-information/address/address.creteilPostalCode';
import { grenoblePostalCode } from 'src/app/views/general-information/address/address.grenoblePostalCode';
import { lillePostalCode } from 'src/app/views/general-information/address/address.lillePostalCode';
import { marseillePostalCode } from 'src/app/views/general-information/address/address.marseillePostalCode';
import { tourcoingPostalCode } from 'src/app/views/general-information/address/address.tourcoingPostalCode';
import { MatomoConstants } from '../constants/matomo.constants';
import { PackageCode } from '../models/enum/packageCode.enum';

export interface ReferenceScale {
  Id: number;
  NombrePersonnes: number;
  Montant: number;
}

const metropoleMapping: {
  [key: string]: {
    code: PackageCode;
    pathType: PathType;
    name: string;
    displayName: string;
    cityName: string;
    residentName: string;
    partnershipLogo: string;
    phoneNumber: string;
    classNameOne: string;
    classNameTwo: string;
    classNameThree: string;
    capPictureName: string;

    bareme: ReferenceScale[];
  };
} = {
  [VyVSharedProductCode.HP]: {
    code: PackageCode.PARISIENNE,
    pathType: PathType.HOUSING_PARIS,
    name: 'Parisienne',
    displayName: 'Parisienne',
    cityName: 'Paris',
    residentName: 'parisien',
    phoneNumber: '01 70 32 19 32',
    classNameOne: 'panelPLogo-OC',
    classNameTwo: 'panelCPLogo-R',
    classNameThree: 'panelPLogo-QC',
    capPictureName: 'plafondsHp',
    partnershipLogo: './assets/common/Images/Paris.svg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 12228 },
      { Id: 1, NombrePersonnes: 1, Montant: 35040 },
      { Id: 2, NombrePersonnes: 2, Montant: 52370 },
      { Id: 3, NombrePersonnes: 3, Montant: 68649 },
      { Id: 4, NombrePersonnes: 4, Montant: 81963 },
      { Id: 5, NombrePersonnes: 5, Montant: 97518 },
      { Id: 6, NombrePersonnes: 6, Montant: 109734 }
    ]
  },
  [VyVSharedProductCode.HT]: {
    code: PackageCode.TOURQUENNOISE,
    pathType: PathType.HOUSING_TOURCOING,
    name: 'Tourquennoise',
    displayName: 'Tourquennoise',
    cityName: 'Tourcoing',
    residentName: 'tourquennois',
    phoneNumber: '03 72 45 03 00',
    classNameOne: 'panelTLogo-OC',
    classNameTwo: 'panelCTLogo-R',
    classNameThree: 'panelTLogo-QC',
    capPictureName: 'plafondsHt',
    partnershipLogo: './assets/common/Images/Tourcoing.svg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 8648 },
      { Id: 1, NombrePersonnes: 1, Montant: 30161 },
      { Id: 2, NombrePersonnes: 2, Montant: 40279 },
      { Id: 3, NombrePersonnes: 3, Montant: 48437 },
      { Id: 4, NombrePersonnes: 4, Montant: 58477 },
      { Id: 5, NombrePersonnes: 5, Montant: 68790 },
      { Id: 6, NombrePersonnes: 6, Montant: 77527 }
    ]
  },
  [VyVSharedProductCode.HL]: {
    code: PackageCode.LILLOISE,
    pathType: PathType.HOUSING_LILLE,
    name: 'Lilloise',
    displayName: 'Lilloise',
    cityName: 'Lille, Lomme et Hellemmes',
    residentName: 'lillois',
    phoneNumber: '03 72 45 03 00',
    classNameOne: 'panelLLogo-OC',
    classNameTwo: 'panelCLLogo-R',
    classNameThree: 'panelLLogo-QC',
    capPictureName: 'plafondsHl',
    partnershipLogo: './assets/common/Images/LilleHellemmesLomme.svg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 8648 },
      { Id: 1, NombrePersonnes: 1, Montant: 30161 },
      { Id: 2, NombrePersonnes: 2, Montant: 40279 },
      { Id: 3, NombrePersonnes: 3, Montant: 48437 },
      { Id: 4, NombrePersonnes: 4, Montant: 58477 },
      { Id: 5, NombrePersonnes: 5, Montant: 68790 },
      { Id: 6, NombrePersonnes: 6, Montant: 77527 }
    ]
  },
  [VyVSharedProductCode.HG]: {
    code: PackageCode.GRENOBLOISE,
    pathType: PathType.HOUSING_GRENOBLE,
    name: 'Grenoble Alpes Métropole',
    displayName: 'Grenoble Alpes Métropole',
    cityName: 'Grenoble Alpes Métropole',
    residentName: 'Grenoble Alpes Métropole',
    phoneNumber: '04 11 97 00 05',
    partnershipLogo: './assets/common/Images/GrenobleAlpesMetropole.svg',
    classNameOne: 'panelGRLogo-OC',
    classNameTwo: 'panelGRLogo-R',
    classNameThree: 'panelGRLogo-QC',
    capPictureName: 'plafondsHg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 8648 },
      { Id: 1, NombrePersonnes: 1, Montant: 30161 },
      { Id: 2, NombrePersonnes: 2, Montant: 40279 },
      { Id: 3, NombrePersonnes: 3, Montant: 48437 },
      { Id: 4, NombrePersonnes: 4, Montant: 58477 },
      { Id: 5, NombrePersonnes: 5, Montant: 68790 },
      { Id: 6, NombrePersonnes: 6, Montant: 77527 }
    ]
  },
  [VyVSharedProductCode.HR]: {
    code: PackageCode.CRISTOLIENNE,
    pathType: PathType.HOUSING_CRETEIL,
    name: 'Cristolienne',
    displayName: 'Cristolienne',
    cityName: 'Créteil',
    residentName: 'cristolien',
    phoneNumber: '01 77 86 02 00',
    classNameOne: 'panelCRLogo-OC',
    classNameTwo: 'panelCRLogo-R',
    classNameThree: 'panelCRLogo-QC',
    capPictureName: 'plafondsHr',
    partnershipLogo: './assets/common/Images/Creteil.svg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 11081 },
      { Id: 1, NombrePersonnes: 1, Montant: 34693 },
      { Id: 2, NombrePersonnes: 2, Montant: 51851 },
      { Id: 3, NombrePersonnes: 3, Montant: 62327 },
      { Id: 4, NombrePersonnes: 4, Montant: 74658 },
      { Id: 5, NombrePersonnes: 5, Montant: 88379 },
      { Id: 6, NombrePersonnes: 6, Montant: 99455 }
    ]
  },
  [VyVSharedProductCode.HE]: {
    code: PackageCode.ETUDIANTE,
    pathType: PathType.HOUSING_ETUDIANTE,
    name: 'Etudiante',
    displayName: 'Etudiant',
    cityName: 'etudiant',
    residentName: 'etudiant',
    phoneNumber: '04 11 97 00 56',
    classNameOne: 'panelELogo-OC',
    classNameTwo: 'panelELogo-R',
    classNameThree: 'panelELogo-QC',
    capPictureName: 'plafondsHl',
    partnershipLogo: '',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 8440 },
      { Id: 1, NombrePersonnes: 1, Montant: 29435 },
      { Id: 2, NombrePersonnes: 2, Montant: 39309 },
      { Id: 3, NombrePersonnes: 3, Montant: 42271 },
      { Id: 4, NombrePersonnes: 4, Montant: 57069 },
      { Id: 5, NombrePersonnes: 5, Montant: 67133 },
      { Id: 6, NombrePersonnes: 6, Montant: 75660 }
    ]
  },
  [VyVSharedProductCode.HA]: {
    code: PackageCode.MARSEILLAISE,
    pathType: PathType.HOUSING_MARSEILLE,
    name: 'Marseillaise',
    displayName: 'Marseillaise',
    cityName: 'Marseille',
    residentName: 'marseillais',
    phoneNumber: '04 11 97 00 04',
    classNameOne: 'panelMARLogo-OC',
    classNameTwo: 'panelMARLogo-R',
    classNameThree: 'panelMARLogo-QC',
    capPictureName: 'plafondsHa',
    partnershipLogo: './assets/common/Images/Marseille.svg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 8648 },
      { Id: 1, NombrePersonnes: 1, Montant: 30161 },
      { Id: 2, NombrePersonnes: 2, Montant: 40279 },
      { Id: 3, NombrePersonnes: 3, Montant: 48437 },
      { Id: 4, NombrePersonnes: 4, Montant: 58477 },
      { Id: 5, NombrePersonnes: 5, Montant: 68790 },
      { Id: 6, NombrePersonnes: 6, Montant: 77527 }
    ]
  },
  [VyVSharedProductCode.BS]: {
    code: PackageCode.BAILLEURS_SOCIAUX,
    pathType: PathType.HOUSING_BAILLEURS_SOCIAUX,
    name: 'Marseillaise',
    displayName: 'Marseillaise',
    cityName: 'Marseille',
    residentName: 'marseillais',
    phoneNumber: '04 11 97 00 04',
    classNameOne: 'panelMARLogo-OC',
    classNameTwo: 'panelMARLogo-R',
    classNameThree: 'panelMARLogo-QC',
    capPictureName: 'plafondsHa',
    partnershipLogo: './assets/common/Images/Marseille.svg',
    bareme: [
      { Id: 0, NombrePersonnes: 1, Montant: 8648 },
      { Id: 1, NombrePersonnes: 1, Montant: 30161 },
      { Id: 2, NombrePersonnes: 2, Montant: 40279 },
      { Id: 3, NombrePersonnes: 3, Montant: 48437 },
      { Id: 4, NombrePersonnes: 4, Montant: 58477 },
      { Id: 5, NombrePersonnes: 5, Montant: 68790 },
      { Id: 6, NombrePersonnes: 6, Montant: 77527 }
    ]
  }
};

export function getMetropoleClassOne(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.classNameOne;
}

export function getMetropoleClassTwo(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.classNameTwo;
}

export function getMetropoleClassThree(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.classNameThree;
}

export function getMetropolePackageCode(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.code;
}

export function getMetropoleBaseName(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.name;
}

export function getMetropoleDisplayName(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.displayName;
}

export function getMetropolePhoneNumber(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.phoneNumber;
}

export function getMetropoleResidentName(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.residentName;
}

export function getMetropoleCityName(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.cityName;
}

export function getMetropoleCapPictureName(idProduit: string): string | undefined {
  return metropoleMapping[idProduit]?.capPictureName;
}

export function getMetropoleBareme(
  idProduit: string
): { Id: number; NombrePersonnes: number; Montant: number }[] | undefined {
  return metropoleMapping[idProduit].bareme;
}

export function getMetropolePartnershipLogo(idProduit: string): string {
  return metropoleMapping[idProduit]?.partnershipLogo;
}

export function metropolePathSwitch(postalCode: string, store: Store) {
  if (postalCode?.startsWith('75')) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING_PARIS }));
  } else if (lillePostalCode.includes(postalCode)) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING_LILLE }));
  } else if (tourcoingPostalCode.includes(postalCode)) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING_TOURCOING }));
  } else if (grenoblePostalCode.includes(postalCode)) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING_GRENOBLE }));
  } else if (creteilPostalCode.includes(postalCode)) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING_CRETEIL }));
  } else if (marseillePostalCode.includes(postalCode)) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING_MARSEILLE }));
  } else if (allowedDepartments.includes(postalCode)) {
    store.dispatch(fromPath.updateType({ pathType: PathType.HOUSING }));
  }
}

export function GetMetropoleOrNot(postalCode: string): boolean {
  if (
    postalCode?.startsWith('75') ||
    lillePostalCode.includes(postalCode) ||
    tourcoingPostalCode.includes(postalCode) ||
    grenoblePostalCode.includes(postalCode) ||
    creteilPostalCode.includes(postalCode) ||
    marseillePostalCode.includes(postalCode)
  )
    return true;
  else return false;
}

export function isMRHAltima(idProduit: string): boolean {
  return (
    idProduit !== PathType.HOUSING &&
    idProduit !== PathType.HOUSING_SOLIDARITY &&
    idProduit !== PathType.HOUSING_BAILLEURS_SOCIAUX
  );
}
